var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"85vh","overflow-y":"auto"}},[_c('school-users-table',{attrs:{"element":_vm.adminOrganization}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }